// src/components/CourseDetails2.js
import React, { useEffect, useState } from "react";
import "./CourseDetails.css";
import CourseEditModal2 from "./CourseEditModal2";
import { apiFetch } from '../api';


export default function CourseDetails2({ title, semesters, season }) {
  const [details, setDetails]   = useState([]);
  const [selectedRow, setSel]   = useState(null);

  /** Daten holen + gleich nach season filtern */
 const loadDetails = async () => {
  try {
    const response = await apiFetch(`get_course_details.php?title=${encodeURIComponent(title)}&season=${encodeURIComponent(season)}`);
    const data = await response.json();
    setDetails(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error("Fehler beim Laden der Kursdetails:", err);
    setDetails([]);
  }
};


  useEffect(() => {
    if (title) loadDetails();
  }, [title, season]);               //  <-- season als Dependency!

  if (!details.length)
    return <p>Keine Termine im Semester “{season || "?"}” für “{title}”.</p>;

  return (
    <div className="course-details">
      <h3>Termine für “{title}” – {season}</h3>

      {/* … Tabelle bleibt unverändert … */}
      <table>
        {/* head … */}
        <tbody>
          {details.map((row, i) => (
            <tr key={row.id ?? i}
                onClick={() => setSel(row)}
                style={{ cursor: "pointer" }}>
              <td>{row.course_date_from}</td>
              <td>{row.course_date_to || "–"}</td>
              <td>{row.course_time}</td>
              <td>{row.course_location}</td>
              <td>{row.course_lecturer}</td>
              <td>{row.course_origin}</td>
              <td>{row.course_application}</td>
              <td>{row.course_description || "–"}</td>
              <td>
                {row.course_link ? (
                  <a href={row.course_link} target="_blank" rel="noreferrer">
                    Plattform
                  </a>
                ) : (
                  "–"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedRow && (
        <CourseEditModal2
          data={selectedRow}
          season={season}
          semesters={semesters}
          onClose={() => setSel(null)}
          onSave={() => { setSel(null); loadDetails(); }}
        />
      )}
    </div>
  );
}
